import { Component, Input } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { IValidationErrorResponse, ValidationModule } from '@bciti/types';

@Component({
    selector: 'app-rss-validator-form-errors',
    templateUrl: './rss-validator-form-errors.component.html',
    styleUrls: ['./rss-validator-form-errors.component.scss'],
})
export class RssValidatorFormErrorsComponent {
    form: FormGroup;
    validationModules = Object.values(ValidationModule);
    submitted = false;
    loading = false;

    @Input() results: IValidationErrorResponse[] = [];

    constructor() {}
}
